/**
 * Validation error patterns
 * Extracted from constants.ts to reduce file size
 */

import type { UserFriendlyError } from "../types";

/**
 * Validation error patterns
 */
export const validationErrorPatterns: Array<{
	pattern: RegExp;
	message: UserFriendlyError | ((match: RegExpMatchArray) => UserFriendlyError);
}> = [
	{
		pattern: /missing required field|is required/i,
		message: {
			title: "Champs manquants",
			message: "Certaines informations obligatoires sont manquantes. Veuillez compléter le formulaire.",
			canRetry: true,
		},
	},
	{
		pattern: /invalid email/i,
		message: {
			title: "Email invalide",
			message: "L'adresse email saisie n'est pas valide. Veuillez la corriger.",
			canRetry: true,
		},
	},
	{
		pattern: /password.*too short|password.*weak/i,
		message: {
			title: "Mot de passe trop faible",
			message: "Le mot de passe doit contenir au moins 8 caractères.",
			canRetry: true,
		},
	},
];

